<template>
  <div>
    <div class="speaker-rotator">
      <ArrowButton
        :left="true"
        :style="{ visibility: visibleControls ? 'visible' : 'hidden' }"
        @click="swiperInstance.slidePrev()"
      />
      <swiper ref="instance" class="rotator" :options="swiperOption">
        <swiper-slide v-for="speaker in speakers" :key="speaker.id">
          <Speaker :data="speaker" @click="openSpeakerDetails" />
        </swiper-slide>
      </swiper>
      <ArrowButton
        :left="false"
        :style="{ visibility: visibleControls ? 'visible' : 'hidden' }"
        @click="swiperInstance.slideNext()"
      />
    </div>
    <SpeakerPopup v-model="speakerPopupVisible" :data="activeSpeaker" />
  </div>
</template>

<script>
import Speaker from "./Speakers/Speaker";
import SpeakerPopup from "./Speakers/SpeakerPopup";

export default {
  name: "Speakers",
  components: { Speaker, SpeakerPopup },
  props: {
    speakers: Array
  },
  data() {
    return {
      speakerPopupVisible: false,
      activeSpeaker: null
    };
  },
  methods: {
    openSpeakerDetails(speaker) {
      this.speakerPopupVisible = true;
      this.activeSpeaker = speaker;
    }
  },
  mounted() {
    console.info("mounted this.maxPerRow", this.maxPerRow);
    this.swiperInstance = this.$refs.instance.swiperInstance;
  },
  computed: {
    swiperOption() {
      return {
        speed: 400,
        keyboard: {
          enabled: true
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 20,
            touchRatio: 0
          },
          600: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          960: {
            slidesPerView: 4,
            spaceBetween: 20
          }
        }
      };
    },
    visibleControls() {
      const conditions = [
        this.$size == "sm" && this.speakers.length > 2,
        this.$size == "md" && this.speakers.length > 3,
        (this.$size == "lg" || this.$size == "xl") && this.speakers.length > 5
      ];
      return conditions.find(t => t);
    }
  }
};
</script>

<style lang="scss" scoped>
.speaker-rotator::v-deep {
  display: flex;
  align-items: center;
  margin: 0;
  position: relative;

  .rotator {
    flex: 1;
    &-slide {
      &__top {
        max-height: 160px;
      }
    }
  }
}

.speaker-rotator.hidden {
  display: none;
}

.swiper-slide {
  .rotator-slide__wrapper {
    height: 100%;
    box-sizing: border-box;
  }
}

.arrow-button {
  margin-top: -30px;
}

@media screen and (max-width: 960px) {
  .speaker-rotator::v-deep .rotator {
    .swiper-wrapper {
      flex-direction: column;
      flex: 1;
    }
  }

  .swiper-container {
    overflow: visible;
  }
}
</style>
